import { MdsIconKind } from "@/design-system/components/icon";
import { getIconKind } from "@/design-system/components/item-list/rows/icon/icon-kind";
import { MDSIconButton, MDSIconButtonVariant } from "@/mds";
import { useThemedCollectionColors } from "@/mds/themes/useThemedCollectionColors";
import styled from "@emotion/styled";

interface Props {
  itemId: string;
  isSelected?: boolean;
  isHighlighted?: boolean;
  toggleSelected: (event: React.MouseEvent) => void;
}

export function CollectionIconWithToggle({
  itemId,
  isSelected,
  isHighlighted,
  toggleSelected,
}: Props) {
  const { iconColor } = useThemedCollectionColors(itemId);
  return (
    <StyledIconButton
      onClick={toggleSelected}
      variant={MDSIconButtonVariant.Transparent}
      iconKind={getIconKind({ isSelected, isHighlighted, defaultIcon: MdsIconKind.Collection })}
      $isSelected={isSelected}
      $isHighlighted={isHighlighted}
      $collectionBackgroundColor={iconColor}
    />
  );
}

const StyledIconButton = styled(MDSIconButton)<{
  $isSelected?: boolean;
  $isHighlighted?: boolean;
  $collectionBackgroundColor: string;
}>`
  padding: 0px;
  height: 16px;
  width: 16px;

  .mds-icon {
    font-size: 18px;
    height: 18px;
    width: 18px;
    color: ${({ theme, $isSelected, $isHighlighted, $collectionBackgroundColor }) =>
      $isSelected
        ? theme.colors.icon.emphasis
        : $isHighlighted
          ? theme.colors.icon.placeholder
          : $collectionBackgroundColor};
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;
